import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'gdp-add-metadata-explaination-popup',
  templateUrl: './add-metadata-explaination-popup.component.html',
  styleUrls: ['./add-metadata-explaination-popup.component.scss']
})
export class AddMetadataExplainationPopupComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  public close() {
    this.activeModal.close();
  }

}
